import React from 'react';
import { ImageAsset } from 'res';
import "./styles.css";

/**
 * @function StatementPage
 * @return {React.Component}
 * @exported true
 * @description The main component for StatementPage
 */
export default function StatementPage(props) {
  return (
    <div className="statement-page">
      <ImageAsset id="SampleStatement" />
    </div>
  )
}
